import { render, staticRenderFns } from "./EditCoinAmountForm.vue?vue&type=template&id=22fe5a60&"
import script from "./EditCoinAmountForm.vue?vue&type=script&lang=js&"
export * from "./EditCoinAmountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports